import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  constructor() {}
  private footerColor: BehaviorSubject<string> = new BehaviorSubject<string>('rgba(57, 122, 158, 1)');
  private footerImage: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private footerStyle: BehaviorSubject<string> = new BehaviorSubject<string>('');

  getFooterColor() {
    return this.footerColor.value;
  }
  setFooterColor(value: string) {
    this.footerColor.next(value);
  }

  getFooterImage() {
    return this.footerImage.value;
  }
  setFooterImage(value: string) {
    this.footerImage.next(value);
  }

  getFooterStyle() {
    return this.footerStyle.value;
  }
  setFooterStyle(value: string) {
    this.footerStyle.next(value);
  }

}
